import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Layout from '../components/Layout';
import CaseDetails from '../components/case/CaseDetails';
import { casesService } from '../services/api.service';
import { message } from 'antd';

export default function CaseDetailsPage() {
    const { id: caseId } = useParams();
    const [documents, setDocuments] = useState([]);
    const [loading, setLoading] = useState(true);
    const [caseDetails, setCaseDetails] = useState(null);
    const [error, setError] = useState(null);

    const fetchCaseDetails = async () => {
        try {
            const data = await casesService.getCaseById(caseId);
            setCaseDetails(data);
        } catch (error) {
            console.error('Error fetching case details:', error);
            setError('Failed to load case details');
        }
    };

    useEffect(() => {
        const loadData = async () => {
            setLoading(true);
            setLoading(false);
        };
        
        loadData();
    }, [caseId]);

    return (
        <Layout>
            <Helmet>
                <title>تفاصيل القضية - نظام إدارة المكتب</title>
            </Helmet>
            <div className="min-h-screen bg-gray-50/30 p-6" dir="rtl">
                <div className="max-w-7xl mx-auto">
                    <CaseDetails 
                        caseId={caseId}
                        caseData={caseDetails}
                        loading={loading}
                    />
                
                </div>
            </div>
        </Layout>
    );
}
